import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import Navbar from "./Navbar";
import { API_BASE_URL } from "./../config";

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateCookie = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/validate_cookie`, {
          method: "POST",
          credentials: "include",
        });

        if (response.ok) {
          const data = await response.json();
          setIsAuthenticated(true);
          setIsAdmin(data.isAdmin);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Error validating cookie", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateCookie();
  }, []);

  if (isLoading) {
    return (
      <div>
        <Navbar />
        <p>Loading...</p> {/* Or some other loading indicator */}
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  // When the user is authenticated, pass isAdmin to Navbar and render children
  return (
    <>
      <Navbar admin={isAdmin} />
      {children}
    </>
  );
};

export default PrivateRoute;